import React from "react";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { ProblemSolution } from "./components/ProblemSolution";
import { PainPoints } from "./components/PainPoints";
import { Tomos } from "./components/Tomos";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { Author } from "./components/Author";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { FloatingCta } from "./components/FloatingCta";
import { UtmifyTracking } from "./components/UtmifyTracking";
export function App() {
  return <div className="w-full bg-white font-sans text-navy-800" data-id="element-0" data-mp="2wip5x1c7ng4e">
      <UtmifyTracking data-id="element-1" data-mp="28tmdqzjya4vn" />
      <main className="w-full" data-id="element-2" data-mp="28suumo7jhzm9">
        <Hero data-id="element-3" data-mp="28s2zfehuu3wi" />
        <Stats data-id="element-4" data-mp="23vkw8j26adma" />
        <ProblemSolution data-id="element-5" data-mp="23vulg4fe8gqx" />
        <PainPoints data-id="element-6" data-mp="23ujl6el5pr4k" />
        <Tomos data-id="element-7" data-mp="23t8heerpojdg" />
        <Bonuses data-id="element-8" data-mp="23ti5txx3yih1" />
        <Offer data-id="element-9" data-mp="3ik7k0rkruvvx" />
        <Guarantee data-id="element-10" data-mp="3ikqz80j1f669" />
        <Testimonials data-id="element-11" data-mp="3ij61y35c994p" />
        <Author data-id="element-12" data-mp="3ihv2ugmu8pjx" />
        <Faq data-id="element-13" data-mp="3mljat0fdtn5p" />
        <FinalCta data-id="element-14" data-mp="3mlat8v8bdto6" />
      </main>

      <footer className="bg-navy-900 px-5 py-8 text-center text-xs text-white/40" data-id="element-15" data-mp="3mk85uxa7a9d0">
        <p className="font-display text-sm font-bold text-white/70" data-id="element-16" data-mp="3rbzngibdp4r0">Sistema Antirrefinamientos™ · Dra. Karito</p>
        <p className="mt-2" data-id="element-17" data-mp="4n4pyuukj8z">
          © {new Date().getFullYear()} Todos los derechos reservados. Este producto no reemplaza el
          criterio clínico profesional.
        </p>
      </footer>

      <FloatingCta data-id="element-18" data-mp="33nq9g2keplaf" />
    </div>;
}